<template>
  <v-container fluid class="pa-0">
    <v-row :class="vistaContratacionDirecta ? 'd-flex justify-space-between' : 'py-0 my-0'">
      <v-col class="my-1 py-1" cols="12" :md="columnContratacionDirecta" >
        <v-text-field
          class="rounded-lg"
          label="Nombre de la plaza*"
          outlined
          dense
          v-model="nombrePlaza"
          :readonly="true"
        />
      </v-col>
      <v-col class="my-1 py-1"
        cols="12"
        :md="columnContratacionDirecta"
        v-role="validRoleFunction({ ver: roles.honorarios })"
      >
        <v-text-field
          class="rounded-lg calculator-icon-bold"
          label="Salario*"
          outlined
          dense
          v-model="honorarios"
          @focus="handleHonorariosFocus"
          append-icon="mdi-calculator"
          @click:append="isView ? null : handleCalculatorClick()"
          :readonly="isView"
          :disabled="desahabilitarAccionCalculo/*fase === 'P14-F4' || fase === 'P14-F5'*/"
          @keypress="restrictToNumbersAndDot"
          @blur="isView ? null : handleCalculatorClick()"
          :error-messages="getErrorMessages('honorarios')"
        />
      </v-col>
      <v-col class="my-1 py-1"
        cols="12"
        :md="columnContratacionDirecta"
        v-role="validRoleFunction({ ver: roles.totalHonorariosMensual })"
      >
        <v-text-field
          class="rounded-lg"
          label="Total salario mensual por plaza*"
          outlined
          :readonly="true"
          dense
          :value="formatCurrency(aportaciones.totalHonorariosMensual)"
          
        />
      </v-col>
    </v-row>
    <v-row :class="vistaContratacionDirecta ? 'd-flex justify-space-between' : 'py-0 my-0'">
      <v-col class="my-1 py-1"
        cols="12"
        :md="columnContratacionDirecta"
        v-role="validRoleFunction({ ver: roles.costoPlaza })"
      >
        <v-text-field
          class="rounded-lg"
          label="Costo por plaza*"
          outlined
          :readonly="true"
          dense
          :value="formatCurrency(aportaciones.costoPlaza)"
        />
      </v-col>
      <v-col class="my-1 py-1" cols="12" :md="columnContratacionDirecta" v-role="validRoleFunction({ ver: roles.plazas })">
        <v-text-field
          class="rounded-lg"
          label="Plazas*"
          outlined
          :readonly="true"
          dense
          :value="aportaciones.plazas"
          
        />
      </v-col>
      <v-col class="my-1 py-1"
        cols="12"
        :md="columnContratacionDirecta"
        v-role="validRoleFunction({ ver: roles.costoTotalPlazas })"
      >
        <v-text-field
          class="rounded-lg"
          label="Costo total plazas*"
          outlined
          :readonly="true"
          :value="formatCurrency(aportaciones.costoTotalPlazas)"
          dense
        />
      </v-col>
    </v-row>
    <v-row :class="vistaContratacionDirecta ? 'd-flex justify-space-between' : 'py-0 my-0'">
      <v-col class="my-1 py-1" cols="12" :md="columnContratacionDirecta" v-role="validRoleFunction({ ver: roles.isss })">
        <v-text-field
          class="rounded-lg"
          label="Instituto Salvadoreño del Seguro Social (ISSS)*"
          outlined
          :readonly="true"
          :value="formatCurrency(aportaciones.isss)"
          dense
        />
      </v-col>
      <v-col class="my-1 py-1" cols="12" :md="columnContratacionDirecta" v-role="validRoleFunction({ ver: roles.afp })">
        <v-text-field
          class="rounded-lg"
          label="Administración de Fondos de Pensiones (AFP)*"
          outlined
          :readonly="true"
          :value="formatCurrency(aportaciones.afp)"
          dense
        />
      </v-col>
      <v-col class="my-1 py-1" cols="12" :md="columnContratacionDirecta" v-role="validRoleFunction({ ver: roles.isr })">
        <v-text-field
          class="rounded-lg"
          label="Impuesto Sobre la Renta (ISR)*"
          outlined
          :readonly="true"
          :value="formatCurrency(aportaciones.isr)"
          dense
        />
      </v-col>
    </v-row>
    <v-row :class="vistaContratacionDirecta ? 'd-flex justify-space-between' : 'py-0 my-0'">
      <v-col class="my-1 py-1" cols="12" :md="columnContratacionDirecta" v-role="validRoleFunction({ ver: roles.totalIsss })">
        <v-text-field
          class="rounded-lg"
          label="Total ISSS*"
          outlined
          :readonly="true"
          :value="formatCurrency(aportaciones.totalIsss)"
          dense
        />
      </v-col>
      <v-col class="my-1 py-1" cols="12" :md="columnContratacionDirecta" v-role="validRoleFunction({ ver: roles.totalAfp })">
        <v-text-field
          class="rounded-lg"
          label="Total AFP*"
          outlined
          :readonly="true"
          :value="formatCurrency(aportaciones.totalAfp)"
          dense
        />
      </v-col>
      <v-col class="my-1 py-1" cols="12" :md="columnContratacionDirecta" v-role="validRoleFunction({ ver: roles.totalIsr })">
        <v-text-field
          class="rounded-lg"
          label="Total ISR*"
          outlined
          :readonly="true"
          :value="formatCurrency(aportaciones.totalIsr)"
          dense
        />
      </v-col>
    </v-row>
    <v-row :class="vistaContratacionDirecta ? 'd-flex justify-space-between' : 'py-0 my-0'">
      <v-col class="my-1 py-1"
        cols="12"
        :md="columnContratacionDirecta"
        v-role="validRoleFunction({ ver: roles.salarioMinimo })"
      >
        <v-text-field
          class="rounded-lg"
          label="Salario mínimo*"
          outlined
          v-model="salarioMinimoLocal"
          :readonly="isView || !rangoSalarialEditable"
          @keypress="restrictRangeToNumbersAndDot($event, salarioMinimoLocal)"
          @input="actualizarValorRango('salarioMinimo', $event)"
          :error-messages="salarioMinimoErrors"
          dense
        />
      </v-col>
      <v-col class="my-1 py-1"
        cols="12"
        :md="columnContratacionDirecta"
        v-role="validRoleFunction({ ver: roles.salarioMaximo })"
      >
        <v-text-field
          class="rounded-lg"
          label="Salario máximo*"
          outlined
          v-model="salarioMaximoLocal"
          :readonly="isView || !rangoSalarialEditable"
          @keypress="restrictRangeToNumbersAndDot($event, salarioMaximoLocal)"
          @input="actualizarValorRango('salarioMaximo', $event)"
          :error-messages="salarioMaximoErrors"
          dense
        />
      </v-col>
    </v-row>
    <v-row :class="vistaContratacionDirecta ? 'd-flex justify-space-between' : 'py-0 my-0'">
      <v-col class="my-1 py-1"
        cols="12"
        :md="columnContratacionDirecta"
        v-role="validRoleFunction({ ver: roles.aguinaldoIndividual })"
      >
        <v-text-field
          class="rounded-lg"
          label="Aguinaldo individual*"
          outlined
          :readonly="true"
          :value="formatCurrency(aportaciones.aguinaldoIndividual)"
          dense
          :hint="calcularAguinaldoConSalarioMin ? 'Aguinaldo calculado con salario mínimo' : 'Aguinaldo calculado con salario base'"
          persistent-hint
        />
      </v-col>
      <v-col class="my-1 py-1"
        cols="12"
        :md="columnContratacionDirecta"
        v-role="validRoleFunction({ ver: roles.aguinaldoTotal })"
      >
        <v-text-field
          class="rounded-lg"
          label="Aguinaldo total*"
          outlined
          :readonly="true"
          :value="formatCurrency(aportaciones.aguinaldoTotal)"
          dense
        />
      </v-col>
    </v-row>
    <v-row class="mb-5" v-if="mostrarCheckCalcularAguinaldo">
      <v-col cols="12">
        <v-checkbox
          class="d-inline-flex"
          v-model="calcularAguinaldoConSalarioMin"
          label="Calcular aguinaldo con salario mínimo"
          :disabled="isView || desahabilitarAccionCalculo"
          hide-details
          dense
        />
      </v-col>
    </v-row>
    <v-row class="py-0 my-0 d-flex justify-center justify-sm-start">
      <v-col class="my-1 py-1" cols="12" md="auto" v-role="validRoleFunction({ ver: roles.verCuadro })">
        <v-btn
          class="lowercase-text px-5"
          outlined
          color="primary"
          style="color: #fff; text-transform: none !important"
          rounded
          @click="verCuadroAportaciones"
        >
          Ver cuadro de aportaciones
        </v-btn>
      </v-col>
      <v-col v-if="mostrarBotonBitacora" cols="12" md="auto" class="d-flex align-center justify-end px-4" align-self="start">
        <v-btn color="#e5e7eb" elevation="0" rounded class="text-none grayTextCalm" @click="openBitacora">
          Bitácora
        </v-btn>
      </v-col> 
    </v-row>
    <BitacoraModal
      v-model="showBitacora"
      :items="bitacoraItems"
      :id-tipo-solicitud="solicitud?.id_tipo_solicitud ?? solicitud?.tipo_solicitud?.id"
    />
  </v-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex/dist/vuex.common.js';
import BitacoraModal from "@/views/solicitudes/components/BitacoraModal.vue";
import bitacoraCuadroAportaciones from "@/mixins/bitacoraCuadroAportaciones.js";
import { decodeFase } from "@/utils/faseEncoding";

export default {
  name: "CuadroAportaciones",
  mixins: [bitacoraCuadroAportaciones],
  components: { BitacoraModal },
  props: {
    faseActivaUsuario: {
      type: Boolean,
      default: false
    },
    fase: {
      type: String,
      default: ""
    },
    nombrePlaza: {
      type: String,
      default: ""
    },
    isView: {
      type: Boolean,
      default: false
    },
    aportaciones: {
      type: Object,
      default: () => ({})
    },
    salarioMinimo: {
      type: Number,
      required: false,
      default: null
    },
    salarioMaximo: {
      type: Number,
      required: false,
      default: null
    },
    rangoSalarialEditable: {
      type: Boolean,
      default: false
    },
    calcularAguinaldo: {
      type: Boolean,
      default: false
    },
    calculadoAguinaldoSalario: {
      type: Boolean,
      default: null
    },
    validRoleFunction: {
      type: Function,
      default: () => ({ action: "show" })
    },
    roles: {
      type: Object,
      default: () => ({
        nombrePlaza: "",
        honorarios: "",
        totalHonorariosMensual: "",
        costoPlaza: "",
        plazas: "",
        costoTotalPlazas: "",
        isss: "",
        afp: "",
        isr: "",
        totalIsss: "",
        totalAfp: "",
        totalIsr: "",
        aguinaldoIndividual: "",
        aguinaldoTotal: "",
        salarioMinimo: "",
        salarioMaximo: "",
        verCuadro: ""
      })
    },
    vistaContratacionDirecta: {
      type: Boolean,
      default: false
    },
    errorValidation: {
      type: Boolean,
      default: false
    },
    mostrarBotonBitacora: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      honorarios: "",
      lastHonorariosEmitted: "",
      lastAguinaldoMinEmitted: false,
      calcularAguinaldoConSalarioMin: false,
      salarioMinimoLocal: "",
      salarioMaximoLocal: ""
    };
  },
  computed:{
    ...mapState({
      solicitud: state => state.solicitud.solicitud
    }),
    desahabilitarAccionCalculo(){ 
      const cumpleFase = ["P14-F3", "P14-F4", "P14-F5"].includes(this.fase);
      const perfilSoloLectura = ['Jefe RRHH', 'Director', 'Jefe UFI'].includes(this.solicitud?.perfil);

      if (this.fase === "P14-F2" && !this.rangoSalarialValido) return true;
      
      //Este es unicamente para el titular
      if(['Titular'].includes(this.solicitud?.perfil)) {
        return !["P14-F3"].includes(this.fase) || !this.solicitud?.fase_activa_usuario;
      };
    
      //if(cumpleFase && perfilSoloLectura) return true;
      if(this.fase == "P14-F2" && perfilSoloLectura && !this.solicitud?.fase_activa_usuario) return true;
      if(cumpleFase && perfilSoloLectura && !this.solicitud?.fase_activa_usuario) return true;
      return cumpleFase && perfilSoloLectura;
    },
    salarioMinimoNumerico() {
      return this.parseMonto(this.salarioMinimoLocal);
    },
    salarioMaximoNumerico() {
      return this.parseMonto(this.salarioMaximoLocal);
    },
    rangoSalarialValido() {
      return this.salarioMinimoNumerico > 0
        && this.salarioMaximoNumerico > 0
        && this.salarioMinimoNumerico <= this.salarioMaximoNumerico;
    },
    salarioMinimoErrors() {
      if (!this.rangoSalarialEditable) return [];
      if (!(this.salarioMinimoNumerico > 0)) return ["Ingrese un salario mínimo mayor a 0"];
      if (this.salarioMaximoNumerico > 0 && this.salarioMinimoNumerico > this.salarioMaximoNumerico) {
        return ["El salario mínimo no puede ser mayor que el salario máximo"];
      }
      return [];
    },
    salarioMaximoErrors() {
      if (!this.rangoSalarialEditable) return [];
      if (!(this.salarioMaximoNumerico > 0)) return ["Ingrese un salario máximo mayor a 0"];
      if (this.salarioMinimoNumerico > 0 && this.salarioMinimoNumerico > this.salarioMaximoNumerico) {
        return ["El salario máximo debe ser mayor o igual al salario mínimo"];
      }
      return [];
    },
    mostrarCheckCalcularAguinaldo(){
      // El check de "Calcular aguinaldo con salario mínimo" no debe salir en la fase P16-F9.
      return this.calcularAguinaldo && this.fase !== 'P16-F9';
    },
    columnContratacionDirecta(){
      if(this.vistaContratacionDirecta){
        return 3;
      }
      return 4
    }
  },
  watch: {
    calculadoAguinaldoSalario: {
      handler(val) {
        if (val !== null) {
          this.calcularAguinaldoConSalarioMin = val ?? false;
        }
      },
      immediate: true
    },
    "aportaciones.honorario": {
      handler(newVal) {
        // Extraer solo el número del valor actual (sin formato)
        const currentClean = String(this.honorarios || '').replace(/[^0-9.]/g, '');
        const currentNum = parseFloat(currentClean);
        const newNum = parseFloat(newVal);

        // Solo actualizar si el valor numérico cambió realmente
        if (newVal && newNum !== currentNum) {
          this.honorarios = newVal;
        }

        // Mantener sincronizado el último valor aplicado desde el padre
        this.lastHonorariosEmitted = newVal || "";
      },
      immediate: true
    },
    salarioMinimo: {
      handler(value) {
        this.salarioMinimoLocal = this.formatearRangoRecibido(value);
      },
      immediate: true
    },
    salarioMaximo: {
      handler(value) {
        this.salarioMaximoLocal = this.formatearRangoRecibido(value);
      },
      immediate: true
    },
    rangoSalarialEditable() {
      this.salarioMinimoLocal = this.formatearRangoRecibido(this.salarioMinimo);
      this.salarioMaximoLocal = this.formatearRangoRecibido(this.salarioMaximo);
    },
    calcularAguinaldoConSalarioMin() {
      if (!this._isMounted) return;
      this.calcularValores();
    }
  },
  mounted() {
    this._isMounted = true;
  },
  methods: {
    formatearRangoRecibido(value) {
      if (value === null || value === undefined || value === "") return "";
      return this.rangoSalarialEditable ? String(value) : this.formatCurrency(value);
    },
    parseMonto(value) {
      const cleanValue = String(value ?? "").replace(/[^0-9.]/g, "");
      if (!cleanValue) return null;
      const parsed = Number(cleanValue);
      return Number.isFinite(parsed) ? parsed : null;
    },
    normalizarMonto(value) {
      const cleanValue = String(value ?? "").replace(/[^0-9.]/g, "");
      const [entero = "", ...decimales] = cleanValue.split(".");
      if (decimales.length === 0) return entero;
      return `${entero}.${decimales.join("").slice(0, 2)}`;
    },
    restrictRangeToNumbersAndDot(event, value) {
      const char = event.key;
      const currentValue = String(value ?? "").replace(/[^0-9.]/g, "");
      if (!/[0-9.]/.test(char)) {
        event.preventDefault();
        return;
      }
      if (char === "." && currentValue.includes(".")) {
        event.preventDefault();
        return;
      }
      const decimals = currentValue.split(".")[1];
      if (currentValue.includes(".") && char !== "." && decimals?.length >= 2) {
        event.preventDefault();
      }
    },
    actualizarValorRango(campo, value) {
      const valueNormalizado = this.normalizarMonto(value);
      if (campo === "salarioMinimo") this.salarioMinimoLocal = valueNormalizado;
      if (campo === "salarioMaximo") this.salarioMaximoLocal = valueNormalizado;

      // Aunque el salario no cambie, un nuevo rango debe volver a enviarse a
      // Planilla en el siguiente clic de la calculadora.
      this.lastHonorariosEmitted = "";

      this.$emit("actualizarRangoSalarial", {
        salarioMinimo: this.salarioMinimoNumerico,
        salarioMaximo: this.salarioMaximoNumerico
      });
    },
    getErrorMessages(field) {
      if (!this.errorValidation) return [];
      
      const value = this.aportaciones[field];
      
      if (value === null || value === undefined || value === 0 || value === "") {
        // this.temporalAlert({
        //   show: true,
        //   message: `Debe calcular las aportaciones. Digite los honorarios`,
        //   type: "warning"
        // });
        return ["Digite los honorarios para el cálculo"];
      }
      
      return [];
    },
    formatCurrency(value) {
      if (!value && value !== 0) return '';
      const numValue = typeof value === 'string' ? parseFloat(value) : value;
      if (isNaN(numValue)) return '';
      return `$${numValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
    },
    handleHonorariosFocus() {
      // Limpiar formato si existe
      const cleanValue = String(this.honorarios).replace(/[^0-9.]/g, '');
      if (cleanValue !== this.honorarios) {
        this.honorarios = cleanValue;
      }
    },
    restrictToNumbersAndDot(event) {
      const char = event.key;
      const value = String(this.honorarios || '');
      
      // Permitir solo números y punto
      if (!/[0-9.]/.test(char)) {
        event.preventDefault();
        return;
      }
      
      // No permitir más de un punto
      if (char === '.' && value.includes('.')) {
        event.preventDefault();
        return;
      }
      
      // Si ya hay un punto, limitar a 2 decimales
      if (value.includes('.')) {
        const parts = value.split('.');
        if (parts[1] && parts[1].length >= 2) {
          event.preventDefault();
        }
      }
    },
    handleCalculatorClick() {
      this.calcularValores();
    },
    calcularValores() {
      if (this.fase === "P14-F2" && !this.rangoSalarialValido) {
        this.temporalAlert({
          show: true,
          message: "Ingrese un salario mínimo y máximo válidos antes de calcular las aportaciones",
          type: "warning"
        });
        return;
      }

      // Obtener el valor limpio sin formato
      const cleanValue = String(this.honorarios).replace(/[^0-9.]/g, '');
      const honorarioValue = parseFloat(cleanValue);
      
      // Validar que sea un número válido
      if (isNaN(honorarioValue) || !cleanValue) {
        this.temporalAlert({
          show: true,
          message: "Debe ingresar un honorario válido",
          type: "warning"
        });
        return;
      }
      
      // Validar rango de salario si los valores existen
      const tieneMinimo = this.salarioMinimoNumerico > 0;
      const tieneMaximo = this.salarioMaximoNumerico > 0;
      
      if (tieneMinimo && honorarioValue < this.salarioMinimoNumerico) {
        this.temporalAlert({
          show: true,
          message: `El salario no puede ser menor que el salario mínimo ${this.formatCurrency(this.salarioMinimoNumerico)}`,
          type: "warning"
        });
        return;
      }
      
      if (tieneMaximo && honorarioValue > this.salarioMaximoNumerico) {
        this.temporalAlert({
          show: true,
          message: `El salario no puede ser mayor que el salario máximo ${this.formatCurrency(this.salarioMaximoNumerico)}`,
          type: "warning"
        });
        return;
      }

      // Emitir el cálculo primero
      if (cleanValue !== this.lastHonorariosEmitted || this.calcularAguinaldoConSalarioMin !== this.lastAguinaldoMinEmitted) {
        this.$emit("calcularAportaciones", cleanValue, this.calcularAguinaldoConSalarioMin);
        this.lastHonorariosEmitted = cleanValue;
        this.lastAguinaldoMinEmitted = this.calcularAguinaldoConSalarioMin;
      }
      
      // Si pasa las validaciones, aplicar formato después de emitir
      // Forzar actualización limpiando y luego formateando
      this.honorarios = '';
      this.$nextTick(() => {
        this.honorarios = this.formatCurrency(honorarioValue);
      });
    },
    verCuadroAportaciones() {
      this.$emit("verCuadroAportaciones");
    },
    ...mapMutations("utils", ["setLoader"])
  }
};
</script>

<style scoped>
.calculator-icon-bold:not(.v-input--is-disabled) ::v-deep .v-input__append-inner .v-icon {
  font-weight: 900 !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

.grayTextCalm {
  color: #6c7280;
}
</style>
